import { useState } from "react";
import { BellRing } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";
import { Button } from "../ui/button";
import { Checkbox } from "../ui/checkbox";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";
import { Input } from "../ui/input";
import { adminHue } from "./adminColor";

export function TaskRemindDialog({ task: t, onClose, onSent }) {
  const [sel, setSel] = useState(new Set(t.assignees));
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const toggle = (id) => setSel((p) => { const n = new Set(p); if (n.has(id)) n.delete(id); else n.add(id); return n; });
  const send = async () => {
    setBusy(true);
    try {
      const all = sel.size === t.assignees.length;
      const { data } = await api.post(`/admin-tasks/${t.id}/remind`, { user_ids: all ? [] : [...sel], note });
      toast.success(data.sent ? `Popup dikirim ke ${data.sent} admin` : "Admin tersebut sudah punya popup yang belum dibaca");
      onSent?.(); onClose();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={onClose}>
      <DialogContent className="max-w-sm" data-testid="task-remind-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><BellRing className="w-5 h-5 text-[#F04E23]" /> Ingatkan Tugas</DialogTitle>
          <DialogDescription className="truncate">{t.title}</DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          {t.assignees.map((id, i) => {
            const h = adminHue(id);
            return (
              <label key={id} className={`flex items-center gap-2 rounded-lg border ${h.border} ${h.bg} px-3 py-2 text-sm cursor-pointer`}>
                <Checkbox checked={sel.has(id)} onCheckedChange={() => toggle(id)} data-testid={`remind-check-${id}`} />
                <span className={`h-2.5 w-2.5 rounded-full ${h.dot}`} />
                <span className="font-medium">{t.assignee_names[i]}</span>
              </label>
            );
          })}
        </div>
        <Input value={note} onChange={(e) => setNote(e.target.value)} placeholder="Pesan singkat (opsional)" maxLength={300} data-testid="remind-note" />
        <Button className="w-full bg-[#F04E23] hover:bg-[#d8431c] text-white" disabled={busy || !sel.size} onClick={send} data-testid="remind-send">Kirim Popup ke {sel.size} Admin</Button>
      </DialogContent>
    </Dialog>
  );
}
